import { POLL_ANSWER, POLL_GET_REQUESTING } from "./constants";

export const getPollRequest = (payload: string) => {
  return {
    type: POLL_GET_REQUESTING,
    payload,
  };
};

export const answerPollRequest = (payload: {
  userId: string;
  answer: string;
  pollId: string;
}) => {
  return {
    type: POLL_ANSWER,
    payload,
  };
};
